module.exports = __webpack_public_path__ + "static/tel1-b184a445cb66e45a4869e38883fd69ea.png";